export const MASK_CHAR = "X";

export const formatValueByMask = (value: string, mask: string) => {
  let formatted = "";
  let numberIndex = 0;

  for (let i = 0; i < mask.length; i++) {
    if (mask[i] === MASK_CHAR) {
      formatted += value[numberIndex] || "";
      numberIndex++;
    } else {
      formatted += mask[i];
    }
  }

  return formatted;
};
